import { z } from "zod";
import { UK_FILTER_SCHEMA } from "../../search/filters/site-sourcing-filter-schema";

export const openSiteSourcingAndSearchToolSchema = {
  inputSchema: z.object({
    filters: UK_FILTER_SCHEMA,
    location: z.object({
      id: z.string(),
      council_name: z.string(),
      gss_code: z.string(),
    }),
  }),
  outputSchema: z.object({
    searchCompleted: z.boolean().describe("If the search was completed"),
  }),
};

export type OpenSiteSourcingAndSearchToolInput = z.infer<typeof openSiteSourcingAndSearchToolSchema.inputSchema>;
export type OpenSiteSourcingAndSearchToolOutput = z.infer<typeof openSiteSourcingAndSearchToolSchema.outputSchema>;
